module.exports = __webpack_public_path__ + "static/media/swift.6dd66996.png";